module.exports = __webpack_public_path__ + "fonts/NotoSans-VariableFont_wdth,wght.b72e420e.ttf";